// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__sNHG4","text":"styles_text__joMc_"};